import Cookies from 'js-cookie';
import { initZanalytics } from '@zillow/universal-analytics';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';
import { isServerSide } from 'src/utils/validators/isServerSide';
import { CLICKSTREAM_SDK, COOKIES_LOOKUP } from 'src/services/auth/constants';
import { initializeClickstreamLogger } from './utils/initializeClickstreamLogger';

export const initializeClickstream = () => {
    if (isServerSide()) {
        // eslint-disable-next-line no-console
        console.warn(
            'initializeClickstream called while window was undefined. Did you accidentally call this server-side?'
        );
        return;
    }
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const { clickstreamConfiguration, isLowerEnvironment } = publicRuntimeConfig;
    const clicksteamSDK = isLowerEnvironment ? CLICKSTREAM_SDK.LOWER_ENVIRONMENT : CLICKSTREAM_SDK.PROD;
    clickstreamConfiguration.zillow.anonymousId = Cookies.get(COOKIES_LOOKUP.SESSION_GUID);
    initializeClickstreamLogger(isLowerEnvironment);
    initZanalytics(window, document, clickstreamConfiguration, undefined, clicksteamSDK);
};
